import React, { Component } from 'react';
import { EndpointOpmanagerRemoteSearcher } from 'client/components/Form/Select2Searchers';
import propTypes from 'prop-types';
import { ButtonWaiting } from 'client/components/Button/ButtonWaiting';

export default class OPTDTesterAddAlarm extends Component {

  static propTypes = {
    endpointId: propTypes.string.isRequired,
    alarmId: propTypes.string,
    onAdd: propTypes.func,
    onChange: propTypes.func,
    isAdding: propTypes.bool,
  };

  handleClick = ev => {
    this.props.onAdd(this.props.alarmId);
  };

  render () {
    const { endpointId, alarmId, isAdding, onChange } = this.props;
    return (
      <div className="input-group xs-mb-15">
        <EndpointOpmanagerRemoteSearcher
          id="optdTesterSelectAlarm" 
          name="alarmId"
          endpointId={endpointId}
          forWhat="alarm"
          onChange={onChange}
          options={{allowClear: true, placeholder: 'Search by alarm entity'}}
          defaultValue={alarmId}
        />
        <span className="input-group-btn">
          <ButtonWaiting disabled={!alarmId} onClick={this.handleClick} type="button" className="btn btn-primary" isWaiting={isAdding}>Add OpManager Alarm</ButtonWaiting>
        </span>
      </div>
    );
  }

}
